<div class="typing-container">
    <span class="typing-text" style="font-size: x-large;"><span class='underline'>I am</span> <{{ animatedText }}></span>
    <span class="typing-cursor"></span>
  </div>